import { EventDataNode } from 'ant-design-vue/lib/tree';
import { H3 } from '@h3/types';
export namespace Tree {
    export enum TreeNodeType {
        /** 加载更多 */
        MoreBtn = 'moreBtn',
    }

    /** 字段类型 */
    export enum FieldType {
        /** 父级字段 */
        Parent = 'parent',

        /** 子级字段 */
        Children = 'children',
    }

    export type KeyType = string | number;

    export type CheckKeys = KeyType[] | { checked: KeyType[]; halfChecked: KeyType[] };

    export interface ITreeNode<T = unknown> {
        source?: T;
        title: string;
        key: string;
        value?: string;
        isLeaf?: boolean;
        selectable?: boolean;
        class?: string;
        children?: ITreeNode<T>[];
    }

    export interface ILoadDataFunction {
        (node: EventDataNode): Promise<void>;
    }

    export interface ITreeListSource {
        filterKey: string;
        filterValue: string;
        pageIndex: number;
        parentKey: string;
        type?: string;
        level?: number;
    }

    export interface IOptionNode {
        label: string;
        value?: string;
        key?: string;
        disabled?: boolean;
        tips?: string;
        control?: H3.Control.IControlLayout | undefined | null;
        options?: IOptionNode[];
        menu?: boolean;
    }

    export interface IGroupQueryValue {
        id: string;
        groupId: string; // 树形组件中存储的key 是唯一的
        name: string;
        filterValue: string[];
        alias?: string | undefined;
    }
}
